module.exports = __webpack_public_path__ + "img/logo.753224b6.png";